import { useContext } from 'react'
import { isFlashHotelType } from 'lib/offer/offerTypes'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

/**
 * Hook to determine if prices should be hidden based on AB test and search type
 * @param offerType - The type of offer (optional, used to check if it's flash)
 * @param metadataHidePricing - Whether the metadata indicates pricing should be hidden
 * @returns Whether prices should be hidden for this offer
 */
export function useHideAnytimePrices(
  offerType?: App.OfferType,
  metadataHidePricing?: boolean
): boolean {
  const globalSearchState = useContext(GlobalSearchStateContext)

  // Hide price if metadata explicitly says to
  if (metadataHidePricing) {
    return true
  }

  return !!(globalSearchState?.hideAnytimePricesEnabled && !isFlashHotelType(offerType))
}

export default useHideAnytimePrices
